import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-employee-toil-history',
  templateUrl: './employee-toil-history.component.html',
  styleUrls: ['./employee-toil-history.component.scss']
})
export class EmployeeToilHistoryComponent implements OnInit {
  @Input() employeeId: string;

  constructor(
    private route: ActivatedRoute,
  ) {}

  ngOnInit(): void {
  }
}
